import React from "react";

export default function IconButton({
	icon = "fas fa-add",
	value,
	className,
	onClick,
	disabled,
}) {
	return (
		<div
			className={`bg-primary-primaryYellow rounded-md p-2 cursor-pointer flex ${className}`}
			onClick={onClick}
		>
			<span className={`${icon} mt-auto mb-auto mr-auto`}></span>
			<p className="mt-auto mb-auto mr-auto">{value}</p>
		</div>
	);
}
